var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('codemirror',{ref:"queryEditor",attrs:{"value":_vm.sparqlQuery,"options":_vm.cmOptions,"id":"codeMirrorElement"},on:{"ready":_vm.onCmReady,"focus":_vm.onCmFocus,"input":_vm.onCmCodeChange}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2ed63f4a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/QueryEditor.vue
// module id = 226
// module chunks = 0